module.exports = __webpack_public_path__ + "static/img/reservation-spep-2.b333980.png";